import React, { useEffect, useState, useContext, useRef } from 'react';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { timesheetuserService } from '../../services/timesheetUserservice';
import { userService } from '../../services/authentication';
import { FaBeer, FaCheck, FaEdit, FaRecycle, FaSearch, FaTrash, FaPlusCircle, FaUpload, FaFileExcel, FaPlus, FaUsers } from "react-icons/fa";
import { MdOutlineCancel, MdOutlineClear } from "react-icons/md";
import { loader } from '../../compnents/loadermd';
import PaginationExample from '../../compnents/pagination';
import { Dialog } from 'primereact/dialog';
import { Paginator } from 'primereact/paginator';
import { Calendar } from 'primereact/calendar';
import { Toast } from 'primereact/toast';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import { formatterhelper } from '../../helpers/dateformatter';
import { ToggleButton } from 'primereact/togglebutton';
import { Message } from 'primereact/message';
import ExcelJS from 'exceljs';


const BulkUsersuploadnew = () => {

  const toast = useRef(null);
  const toastTopCenter = useRef(null);
  const [formData, setFormData] = useState({
    client: '',
    subclient: '',
    BilledMinutes: '',
    Count: '',
    Minutes: '',
    Remarks: '',
    Task: '',
    budget_hours: '',
    date: 0,
    querycount: '',
    remaining_hrs: ''
  });

  const [formdata2, setForm2Data] = useState({ "employeeid": "", "userid": "", "name": "", "date_of_joining": "", "date_of_handovers": "", "project_name": "", "departmentname": "", "roletype": "", "project": "", "costcenter": "", "isadder": "0", "approver": "", "role": "" });
  const [formdataedit, setFormDataedit] = useState({ "id":"","employeeid": "", "userid": "", "name": "", "date_of_joining": "", "date_of_handovers": "", "project_name": "", "departmentname": "", "roletype": "", "project": "", "costcenter": "", "isadder": '0', "approver": "", "role": "","status":'' });

  const [users, setUsers] = useState([]);
  const [isloaded, setLoading] = useState(true);
  const [isdialog, setuserdialog] = useState(false);
  const [isdialogedit, setusereditdialog] = useState(false);
  const [ismultiuploaddialog, setmultiuploaddialog] = useState(false);
  const emptyMultiUserRow = { "employeeid": "", "userid": "", "name": "", "date_of_joining": "", "date_of_handovers": "", "project_name": "", "departmentname": "", "teamname": "", "roletype": "", "project": "", "costcenter": "", "isadder": "0", "approver": "", "role": "" };
  const [multiuserrows, setMultiuserrows] = useState([{ ...emptyMultiUserRow }]);
  const [totalpages, setPages] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [last_page, setLastpage] = useState(1);
  const [per_page, setperpage] = useState(0);

  const [deptcomp, setdeptcomp] = useState([]);
  const [rolecomp, setrolecomp] = useState([]);
  const [teamcomp, setteamcomp] = useState([]);
  const [projectcomp, setprojectcomp] = useState([]);
  const [userscomp, setuserscomp] = useState([]);
  const [costcentercomp, setcostcomp] = useState([]);
  const [deptnames, setdeptnames] = useState([]);
  const [teamnames, setteamnames] = useState([]);
  const [rolenames, setrolenames] = useState([]);
  const [projectnames, setprojectnames] = useState([]);
  const [approvernames, setapprovernames] = useState([]);
  const [costcenternames, setcostcenternames] = useState([]);
  const [isexceluploaddialog, setexceluploaddialog] = useState(false);
  const [selectedExcelFile, setSelectedExcelFile] = useState(null);
  const [isuploadingexcel, setuploadingexcel] = useState(false);
  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(15);
  const [searchQuery, setSearchQuery] = useState('');
  const userdata = localStorage.getItem('user') != '' ? JSON.parse(localStorage.getItem('user')) : {};

  const [newErrors, setErrors] = useState({'adduser' : { "employeeid": "", "userid": "", "name": "", "date_of_joining": "", "date_of_handovers": "", "project_name": "", "departmentname": "", "roletype": "", "project": "", "costcenter": "", "isadder": "", "approver": "", "role": "" },
  'edituser' : { "employeeid": "", "userid": "", "name": "", "date_of_joining": "", "date_of_handovers": "", "project_name": "", "departmentname": "", "roletype": "", "project": "", "costcenter": "", "isadder": "", "approver": "", "role": "" }
});
  const [iseditsubmitted, setEditsubmitted] = useState(false);

  useEffect(() => {
    getUsers();
    getdependencies();
  }, [iseditsubmitted]);


  function isverfiedCom({ status }) {
    let comp = null;
    switch (status) {
      case 1:
        comp = (<FaCheck />)
        break;
      default:
        comp = (<MdOutlineClear />)
    }
    return comp;
  }


  const getUsers = (pageno) => {
    try {
      setLoading(false);
      let emparra = [];
      let emppages = [];
      timesheetuserService.getusers(pageno).then((response) => {
        response.data.data.data.forEach((value, index) => {
          emparra.push((
            <tr key={index}>
              <td>{value.id}</td>
              <td>{value.name}</td>
              <td>{value.project}</td>
              <td>{value.role}</td>
              <td>{value.verified_on}</td>
              <td>{isverfiedCom({ status: value.status })}</td>
              <td><FaRecycle className='custom-cursor-style' onClick={()=>resetpass(value)} /></td>
              <td><FaEdit className='custom-cursor-style' onClick={() => edittoggle({ data: value })} /></td>
            </tr>
          ));
        });
        //  console.log('response data');
        //  console.log(response.data.data.total);
        for (let i = 0; i < response.data.data.total; i++) {
          emppages.push(i);
        }
        setLoading(true);
        setUsers(emparra);
        setPages(emppages);
        setCurrentPage(response.data.data.current_page);
        setLastpage(response.data.data.last_page);
        setperpage(response.data.data.per_page);
      }).catch((error) => {
        setLoading(true);
        console.log(error);
      });
    } catch (error) {
      console.log(error);
    }
    // console.log(pageno);
  }

  const edittoggle = ({ data }) => {
    data.departmentname = data.dept;
    setFormDataedit(data);
    setusereditdialog(true);
  };


  const onPageChange = (event) => {
    setFirst(event.first);
    setRows(event.rows);
    let pageno = 1;
    if (event.first == 0) {
      pageno = 1;
    } else {
      pageno = ((event.first / rows) + 1);
    }

    if (searchQuery.trim().length > 0) {
      searchusersbyquery({ query: searchQuery, pageno });
    } else {
      getUsers(pageno);
    }
    // console.log(pageno);
  };

  const resetpass = (objdata) => {
    // console.log("reset pass");
    confirmDialog({
      message: 'Are you sure you want to proceed?',
      header: 'Password Reset Confirmation',
      icon: 'pi pi-exclamation-triangle',
      defaultFocus: 'accept',
      accept: () => resetpass_({objdata}),
     //  accept,
      reject
   });
  }

  const reject = () => {
    toast.current.show({ severity: 'warn', summary: 'Password Reset', detail: 'Canceled', life: 3000 });
  }

  const resetpass_ = ({objdata}) =>{
    try{
      userService.resetpassword(objdata).then((response)=>{
        if(response.status == 200){
          // toastTopCenter.current.show({ severity: 'success', summary: 'Password Reset', detail: response.data.data, life: 3000 });
        }else{
          // toast.current.show({ severity: 'error', summary: 'Password Reset', detail: 'Not reset', life: 4000 });
        } 
      }).catch((error)=>{
          // console.log(error);
          // toast.current.show({ severity: 'error', summary: 'Password Reset', detail: 'Somthing went wrong', life: 3000 });
      });
    }catch(error){
      //  console.log(error);   
    }
  }

  const validateForm = ({formdata,type}) => {
    let valid = true;
    const newErrors = {};
    if (formdata.userid == '') {
      newErrors.userid = 'UserId is required';
      valid = false;
    }
    if (formdata.name == '') {
      newErrors.name = 'Name is required';
      valid = false;
    }

    // if (formdata.date_of_joining == '') {
    //   newErrors.date_of_joining = 'Date of joining is required';
    //   valid = false;
    // }

    if (formdata.project == '') {
      newErrors.project = 'Project is required';
      valid = false;
    }

    if (formdata.project_name == '') {
      newErrors.project_name = 'Project name is required';
      valid = false;
    }
    if (formdata.departmentname == '') {
      newErrors.departmentname = 'Department is required';
      valid = false;
    }

    if (formdata.roletype == '') {
      newErrors.roletype = 'Role type is required';
      valid = false;
    }

    if (formdata.costcenter == '') {
      newErrors.costcenter = 'Costcenter is required';
      valid = false;
    }

    if (formdata.approver == '') {
      newErrors.approver = 'Approver is required';
      valid = false;
    }

    if (formdata.role == '') {
      newErrors.role = 'User type is required';
      valid = false;
    }


    if (formdata.employeeid == '') {
      newErrors.employeeid = 'Employee is required';
      valid = false;
    }

    if (formdata.teamname == '') {
      newErrors.teamname = 'Teamname is required';
      valid = false;
    }


    // if (formdata.isadder == '') {
    //   newErrors.isadder = 'Isaddar is required';
    //   valid = false;
    // }
    
    if(type == 'add'){
        setErrors((prevData) => ({...prevData,adduser:newErrors}));     
    }else {
      // return;
      setErrors((prevData) => ({...prevData,edituser:newErrors}));  
    }
    return valid;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm2Data((prevData) => ({
      ...prevData,
      [name]: value,
    }));

   
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm({formdata:formdata2,type:'add'})) {
      adduser({ obj: formdata2 });
    }
  };
  function adduser({ obj }) {
    obj = JSON.stringify(obj);
    timesheetuserService.addUser({ formdata: obj }).then((response) => {
      // console.log(response);
      if (response.status == 200) {
        toast.current.show({ severity: 'success', summary: "User", detail: `User added successfully!`, life: 3000 });
        setuserdialog(false);
      } else if (response.status == 400) {
        toast.current.show({ severity: 'error', summary: "User", detail: `${response.data.data}`, life: 3000 });
      }
      else {
        toast.current.show({ severity: 'error', summary: "User", detail: `${response.data.data}`, life: 3000 });
      }
    });
  }

  const addMultiUserRow = () => {
    setMultiuserrows((prev) => [...prev, { ...emptyMultiUserRow }]);
  };

  const removeMultiUserRow = (index) => {
    setMultiuserrows((prev) => prev.length > 1 ? prev.filter((_, i) => i !== index) : prev);
  };

  const handleMultiUserRowChange = (index, field, value) => {
    setMultiuserrows((prev) => {
      const updated = [...prev];
      updated[index] = { ...updated[index], [field]: value };
      return updated;
    });
  };

  const multiUserRequiredFields = ['userid', 'name', 'project_name', 'departmentname', 'teamname', 'roletype', 'project', 'approver', 'costcenter', 'employeeid', 'role'];

  const isMultiUserRowEmpty = (row) => {
    return multiUserRequiredFields.every((field) => row[field] === '' || row[field] === undefined);
  };

  const isMultiUserRowComplete = (row) => {
    return multiUserRequiredFields.every((field) => row[field] !== '' && row[field] !== undefined);
  };

  const submitMultiUsers = async () => {
    const rowsToSubmit = multiuserrows.filter((row) => !isMultiUserRowEmpty(row));

    if (rowsToSubmit.length === 0) {
      toast.current.show({ severity: 'warn', summary: 'Multi User Upload', detail: 'Add at least one user row', life: 3000 });
      return;
    }

    for (let i = 0; i < rowsToSubmit.length; i++) {
      const missing = multiUserRequiredFields.filter((field) => rowsToSubmit[i][field] === '' || rowsToSubmit[i][field] === undefined);
      if (missing.length > 0) {
        toast.current.show({ severity: 'error', summary: 'Multi User Upload', detail: `Row ${i + 1}: required fields missing`, life: 3000 });
        return;
      }
    }

    let successCount = 0;
    let failCount = 0;

    for (const row of rowsToSubmit) {
      try {
        const response = await timesheetuserService.addUser({ formdata: JSON.stringify(row) });
        if (response && response.status == 200) {
          successCount++;
        } else {
          failCount++;
        }
      } catch (error) {
        failCount++;
      }
    }

    toast.current.show({
      severity: failCount === 0 ? 'success' : (successCount === 0 ? 'error' : 'warn'),
      summary: 'Multi User Upload',
      detail: `${successCount} user(s) added successfully${failCount > 0 ? `, ${failCount} failed` : ''}`,
      life: 4000
    });

    if (successCount > 0) {
      getUsers(1);
    }

    setMultiuserrows([{ ...emptyMultiUserRow }]);
    setmultiuploaddialog(false);
  };

  const downloadExcelTemplate = async () => {
    try {
      const headers = [
        'Email address', 'Name', 'Date of Joining (YYYY-MM-DD)', 'Date of Handover to Operations (YYYY-MM-DD)',
        'Name of the Project', 'Department Name', 'Team Name', 'Role', 'User Type', 'project',
        'Aprover', 'Cost Center', 'Employee ID', 'Add Permission'
      ];

      const dateColumns = ['C', 'D'];
      const dateFormula = (col, row) => `AND(LEN(${col}${row})=10,MID(${col}${row},5,1)="-",MID(${col}${row},8,1)="-",ISNUMBER(VALUE(LEFT(${col}${row},4))),ISNUMBER(VALUE(MID(${col}${row},6,2))),ISNUMBER(VALUE(RIGHT(${col}${row},2))))`;

      const dropdownColumns = {
        'F': deptnames,
        'G': teamnames,
        'H': rolenames,
        'I': ['Manager', 'Normal User'],
        'J': projectnames,
        'K': approvernames,
        'L': costcenternames,
        'N': ['Enabled', 'Disabled']
      };

      const workbook = new ExcelJS.Workbook();

      const listSheet = workbook.addWorksheet('Lists');
      listSheet.state = 'hidden';
      const listColumns = Object.keys(dropdownColumns);
      const listRanges = {};
      listColumns.forEach((col, idx) => {
        const values = dropdownColumns[col];
        const listColLetter = String.fromCharCode(65 + idx);
        values.forEach((val, i) => {
          listSheet.getCell(`${listColLetter}${i + 1}`).value = val;
        });
        listRanges[col] = values.length > 0 ? `Lists!$${listColLetter}$1:$${listColLetter}$${values.length}` : null;
      });

      const sheet = workbook.addWorksheet('Users Template');
      sheet.addRow(headers);
      sheet.getRow(1).font = { bold: true };
      sheet.columns.forEach((column) => { column.width = 26; });
      dateColumns.forEach((col) => {
        sheet.getColumn(col).numFmt = '@';
      });

      const ROW_COUNT = 200;
      for (let row = 2; row <= ROW_COUNT + 1; row++) {
        listColumns.forEach((col) => {
          const range = listRanges[col];
          if (range) {
            sheet.getCell(`${col}${row}`).dataValidation = {
              type: 'list',
              allowBlank: true,
              formulae: [range],
              showErrorMessage: true,
              errorStyle: 'stop',
              error: 'Please select a value from the dropdown list'
            };
          }
        });
        dateColumns.forEach((col) => {
          sheet.getCell(`${col}${row}`).dataValidation = {
            type: 'custom',
            allowBlank: true,
            formulae: [dateFormula(col, row)],
            showErrorMessage: true,
            errorStyle: 'stop',
            errorTitle: 'Invalid date format',
            error: 'Enter the date as text in YYYY-MM-DD format (e.g. 2026-08-25).'
          };
        });
      }

      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = 'Bulk_User_Upload_Template.xlsx';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.log(error);
      toast.current.show({ severity: 'error', summary: 'Excel Template', detail: 'Could not generate template', life: 3000 });
    }
  };

  const selectExcelFileForUpload = (event) => {
    setSelectedExcelFile(event.target.files[0] || null);
  };

  const fileToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(String(reader.result).split('base64,')[1]);
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });
  };

  const processSelectedExcelFile = async () => {
    const file = selectedExcelFile;
    if (!file) {
      toast.current.show({ severity: 'error', summary: 'Excel Upload', detail: 'Select a file first', life: 3000 });
      return;
    }
    setuploadingexcel(true);
    try {
      const file_data = await fileToBase64(file);
      const response = await timesheetuserService.bulkuploadusersnew({ file_data });

      if (response && response.status == 200) {
        const result = response.data.data;
        toast.current.show({
          severity: result.invalid > 0 || result.skipped > 0 ? 'warn' : 'success',
          summary: 'Excel Upload',
          detail: `${result.inserted} user(s) added, ${result.skipped} skipped (duplicate), ${result.invalid} invalid`,
          life: 5000
        });
        setSelectedExcelFile(null);
        setexceluploaddialog(false);
        if (result.inserted > 0) {
          getUsers(1);
        }
      } else {
        toast.current.show({ severity: 'error', summary: 'Excel Upload', detail: (response && response.data && response.data.data) || 'Upload failed', life: 8000 });
      }
    } catch (error) {
      console.log(error);
      toast.current.show({ severity: 'error', summary: 'Excel Upload', detail: 'Could not upload the file', life: 3000 });
    } finally {
      setuploadingexcel(false);
    }
  };

  const edithandleChange = (e) => {
    const { name, value } = e.target;
    setFormDataedit((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const edithandleSubmit = (e) => {
    e.preventDefault();
    // console.log(formdataedit);
    if (!validateForm({formdata:formdataedit,type:'edit'})) {
          return;      
    }
    
   
    let strobj = JSON.stringify(formdataedit);
    timesheetuserService.updateusr({formdata:strobj}).then((response)=>{
       console.log(response);
       if(response.status == 200){
          toast.current.show({ severity: 'success', summary: "User", detail: `Updated successfully!`, life: 3000 });   
          getUsers(1);
          setusereditdialog(false);
       }else{
          toast.current.show({ severity: 'error', summary: "User", detail: `${response.data.data}`, life: 3000 }); 
          
       }  
    }).catch((error)=>{
       console.log(error);
       toast.current.show({ severity: 'error', summary: "User", detail: `Error`, life: 3000 });
       setusereditdialog(false);
    });
    
    // console.log(formdataedit);
  }

  

  function updateuserstatus(e,id){
      
    confirmDialog({
      message: 'Are you sure you want to proceed?',
      header: 'User Account Activation',
      icon: 'pi pi-exclamation-triangle',
      defaultFocus: 'accept',
      accept: () => {
        let obj = {
          'id':id,
          'status':e.value ? 1 : 0
        }
        obj = JSON.stringify(obj);
        timesheetuserService.updateuserstatus({formdata:obj}).then((response)=>{
          if(response.status == 200){
              toast.current.show({ severity: 'success', summary: "User", detail: `${response.data.data}`, life: 3000 });  
              getUsers(1);
              setusereditdialog(false); 
          }else{
              toast.current.show({ severity: 'error', summary: "User", detail: `${response.data.data}`, life: 3000 }); 
          }   
        }).catch((error)=>{
            toast.current.show({ severity: 'error', summary: "User", detail: `Error`, life: 3000 }); 
            setusereditdialog(false); 
        });
      },
     //  accept,
      reject : ()=> {
        toast.current.show({ severity: 'warn', summary: 'User account activation', detail: 'Canceled', life: 3000 });
      }
   }); 
  }


  function getdependencies() {
    try {
      let depttemp = [];
      let teamtemp = [];
      let roletemp = [];
      let projecttemp = [];
      let usertemp = [];
      let costcentertemp = [];

      timesheetuserService.getdept().then((response) => {
        try {
          if (response != undefined && response.data != undefined) {
            response.data.data.forEach((value, item) => {
              depttemp.push(<option value={value.dept_name}>{value.dept_name}</option>);
            });
            setdeptcomp(depttemp);
            setdeptnames(response.data.data.map((value) => value.dept_name));
          }
        } catch (error) {
          console.log(error);
        }

      });

      timesheetuserService.getteam().then((response) => {
        if (response != undefined && response.data != undefined) {
          response.data.data.forEach((value, item) => {
            teamtemp.push(<option value={value.team_name}>{value.team_name}</option>);
          });
          setteamcomp(teamtemp);
          setteamnames(response.data.data.map((value) => value.team_name));
        }
      });

      timesheetuserService.getrole().then((response) => {
        if (response != undefined && response.data != undefined) {
          let rolenamestemp = [];
          response.data.data.forEach((value, item) => {
            if(userdata.id != 1){
                if(value.rolename != 'admin'){
                    roletemp.push(<option value={value.rolename}>{value.rolename}</option>);
                    rolenamestemp.push(value.rolename);
                }

            }else{
                roletemp.push(<option value={value.rolename}>{value.rolename}</option>);
                rolenamestemp.push(value.rolename);
            }
          });
          setrolecomp(roletemp);
          setrolenames(rolenamestemp);
        }
      });


      timesheetuserService.getproject().then((response) => {
        if (response != undefined && response.data != undefined) {
          response.data.data.forEach((value, item) => {
            projecttemp.push(<option value={value.name}>{value.name}</option>);
          });
          setprojectcomp(projecttemp);
          setprojectnames(response.data.data.map((value) => value.name));
        }
      });

      timesheetuserService.getApprover().then((response) => {
        if (response != undefined && response.data != undefined) {
          response.data.data.forEach((value, item) => {
            usertemp.push(<option value={value.id}>{value.name}</option>);
          });
          setuserscomp(usertemp);
          setapprovernames(response.data.data.map((value) => value.name));
        }
      });

      timesheetuserService.getcostcenter().then((response) => {
        if (response != undefined && response.data != undefined) {
          response.data.data.forEach((value, item) => {
            costcentertemp.push(<option value={value.id}>{value.costcentername}</option>);
          });
          setcostcomp(costcentertemp);
          setcostcenternames(response.data.data.map((value) => value.costcentername));
        }
      });
    } catch (error) {
      console.log(error);
    }
  }

  const searchusersbyquery = ({ query, pageno }) => {
    let emparra = [];
    let emppages = [];
    timesheetuserService.searchusers({ searchq: query, pageno }).then((response) => {
      response.data.data.data.forEach((value, index) => {
        emparra.push((
          <tr key={index}>
            <td>{value.id}</td>
            <td>{value.name}</td>
            <td>{value.project}</td>
            <td>{value.role}</td>
            <td>{value.verified_on}</td>
            <td>{isverfiedCom({ status: value.status })}</td>
            <td><FaRecycle className='custom-cursor-style' onClick={()=>resetpass(value)} /></td>
            <td><FaEdit className='custom-cursor-style' onClick={() => edittoggle({ data: value })} /></td>
          </tr>
        ));
      });
      for (let i = 0; i < response.data.data.total; i++) {
        emppages.push(i);
      }
      setLoading(true);
      setUsers(emparra);
      setPages(emppages);
      setCurrentPage(response.data.data.current_page);
      setLastpage(response.data.data.last_page);
      setperpage(response.data.data.per_page);
    }).catch((error) => {
      setLoading(true);
      console.log(error);
    });
  };

  const onSearchChange = (event) => {
    const value = event.target.value;
    setSearchQuery(value);
    if (value.trim().length < 1) {
      setFirst(0);
      getUsers(1);
    }
  };

  function searchusers(event){
     if (event.key === 'Enter') {
      setFirst(0);
      searchusersbyquery({ query: event.target.value, pageno: 1 });
    }
  }

  return (
    <>
      <Toast ref={toast} />
      <ConfirmDialog />
      <Toast ref={toastTopCenter} position="top-center" />
      <div className="invisible-divider-sm"></div>

     
      <div className='card card-custom-style card-style-padding'>
        <div className='row'>
          <div className='col-md-12'>
            <Message
              severity="info"
              className='custom-width-style'
              style={{ width: '100%', justifyContent: 'flex-start' }}
              text="To add users in bulk: download the Excel Template, fill in the details (use the dropdowns for Department, Team, Role, User Type, project, Approver, Cost Center and Add Permission), then upload it back using Excel Upload. Enter Date of Joining / Date of Handover as text in YYYY-MM-DD format (e.g. 2026-08-25) — other formats will be rejected on upload. You can also add users one at a time with Add User, or enter a few users directly in a table using Multi User Upload."
            />
          </div>
        </div>
        <div className='row'>
          <div className='col-md-12'>
            <Message
              severity="error"
              className='custom-width-style'
              style={{ width: '100%', justifyContent: 'flex-start' }}
              text="The upload will fail if the 'Email address' or 'Employee ID' column has duplicate values. Please check both columns for duplicates before uploading. Also, the date format should match the given header column (YYYY-MM-DD)."
            />
          </div>
        </div>
        <br />
        <div className="row" style={{ alignItems: 'center' }}>
          <div className="col-md-4">
            <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
              <Button className='custom-btn-style' title="Add User" onClick={() => setuserdialog(true)}>
                <FaPlus />
              </Button>
              <Button className='custom-btn-style' title="Multi User Upload" onClick={() => setmultiuploaddialog(true)}>
                <FaUsers />
              </Button>
            </div>
          </div>
          <div className="col-md-4">
            <div style={{ display: 'flex', gap: '8px', alignItems: 'center', paddingLeft: '12px', borderLeft: '1px solid #e5e7eb' }}>
              <Button
                className='custom-btn-style search-box-height'
                style={{ backgroundColor: '#217346', borderColor: '#217346', color: '#ffffff' }}
                onClick={() => downloadExcelTemplate()}
              >
                <FaFileExcel style={{ marginRight: '6px' }} /> Template
              </Button>
              <Button
                className='custom-btn-style search-box-height'
                style={{ backgroundColor: '#7c3aed', borderColor: '#7c3aed', color: '#ffffff' }}
                onClick={() => setexceluploaddialog(true)}
              >
                <FaUpload style={{ marginRight: '6px' }} /> Upload
              </Button>
            </div>
          </div>
          <div className="col-md-4">
            <span className="p-input-icon-left pull-right">
              {/* <i className="pi pi-search" /> */}
              <FaSearch />
              <InputText className="search-box-height" placeholder="Press and Enter" value={searchQuery} onChange={onSearchChange} onKeyDown={(e)=>{searchusers(e)}}/>
            </span>
          </div>
        </div>

      </div>
      <div className="invisible-divider-sm"></div>
      <div className='card card-custom-style card-style-padding'>
        <div className='row'>
          <div className='col-md-4'></div>
          <div className='pagination col-md-8'>
            {/* <PaginationExample items={totalpages} currentPaged={currentPage} lastpage={last_page} perpage={per_page} getuserfun={getUsers}/> */}
            {isloaded ? (<Paginator first={first} rows={rows} totalRecords={totalpages.length} rowsPerPageOptions={[15]} onPageChange={onPageChange} />) : (<></>)}
          </div>
        </div>
        <div className="row">
          <Dialog header="Add User" visible={isdialog} style={{ width: '80%' }} onHide={() => setuserdialog(false)}>
            <form onSubmit={handleSubmit}>
              <div className='col-md-12'>
                <div className='row'>
                  <div className='col-md-4'>
                    <label>User Id Or Email address <span className='error'>*</span></label>
                    <input type='text' name='userid' required value={formdata2.userid} class="form-control" onChange={(e) => handleChange(e)} />
                    <span className='error'>{newErrors.adduser.userid}</span>
                  </div>
                  <div className='col-md-4'>
                    <label>Name <span className='error'>*</span></label>
                    <input type='text' required name='name' value={formdata2.name} class="form-control" onChange={(e) => handleChange(e)} />
                    <span className='error'>{newErrors.adduser.name}</span>
                  </div>
                  <div className='col-md-4'>
                    <label>Date of Joining <span className='error'>*</span></label>
                    <br />
                    <Calendar
                      className='calender-custom-style'
                      name="date_of_joining" required value={formdata2.date_of_joining} onChange={(e) => handleChange(e)} style={{ width: '100%' }} />
                    <span className='error'>{newErrors.adduser.date_of_joining}</span>
                  </div>

                  <div className='col-md-3'>
                    <br />
                    <label>Date of Handover to Operations</label>

                    <Calendar className='calender-custom-style'
                      name="date_of_handovers" value={formdata2.date_of_handovers} onChange={(e) => handleChange(e)} style={{ width: '100%' }} />
                  </div>

                  <div className='col-md-6'>
                    <br />
                    <label>Name of the Project <span className='error'>*</span></label>
                    <br />
                    <input type='text' required name='project_name' value={formdata2.project_name} class="form-control" onChange={(e) => handleChange(e)} />
                    <span className='error'>{newErrors.adduser.project_name}</span>
                  </div>

                  <div className='col-md-3'>
                    <br />
                    <label>Department Name <span className='error'>*</span></label>
                    <br />
                    <select class="form-control" required name="departmentname" value={formdata2.departmentname} onChange={(e) => handleChange(e)}>
                      <option value="">Select</option>
                      {deptcomp}
                    </select>
                    <span className='error'>{newErrors.adduser.departmentname}</span>
                  </div>

                  <div className='col-md-3'>
                    <br />
                    <label>Team Name <span className='error'>*</span></label>
                    <br />
                    <select class="form-control" required name="teamname" value={formdata2.teamname} onChange={(e) => handleChange(e)}>
                      <option value="">Select</option>
                      {teamcomp}
                    </select>
                    <span className='error'>{newErrors.adduser.teamname}</span>
                  </div>

                  <div className='col-md-3'>
                    <br />
                    <label>Role <span className='error'>*</span></label>
                    <br />
                    <select class="form-control" required name="roletype" value={formdata2.roletype} onChange={(e) => handleChange(e)}>
                      <option value="">Select</option>
                      {rolecomp}
                    </select>
                    <span className='error'>{newErrors.adduser.roletype}</span>
                  </div>
                  <div className='col-md-3'>
                    <br />
                    <label>User Type <span className='error'>*</span></label>
                    <br />
                    <select class="form-control" required name="role" onChange={(e) => handleChange(e)}>
                      <option value="">Select</option>
                      <option value="UL1">Manager</option>
                      <option value="CL1">Normal User</option>
                    </select>
                    <span className='error'>{newErrors.adduser.role}</span>
                  </div>

                  <div className='col-md-3'>
                    <br />
                    <label>project <span className='error'>*</span></label>
                    <br />
                    <select class="form-control" required name="project" onChange={(e) => handleChange(e)}>
                      <option value="">Select</option>
                      {projectcomp}
                    </select>
                    <span className='error'>{newErrors.adduser.project}</span>
                  </div>
                  <div className='col-md-3'>
                    <br />
                    <label>Aprover <span className='error'>*</span></label>
                    <br />
                    <select class="form-control" required name="approver" onChange={(e) => handleChange(e)}>
                      <option value="">Select</option>
                      {userscomp}
                    </select>
                    <span className='error'>{newErrors.adduser.approver}</span>
                  </div>
                  <div className='col-md-3'>
                    <br />
                    <label>Cost Center <span className='error'>*</span></label>
                    <br />
                    <select class="form-control" required name="costcenter" onChange={(e) => handleChange(e)}>
                      <option value="">Select</option>
                      {costcentercomp}
                    </select>
                    <span className='error'>{newErrors.adduser.costcenter}</span>
                  </div>
                  <div className='col-md-3'>
                    <br />
                    <label>Employee ID <span className='error'>*</span></label>
                    <br />
                    <input type='number' required name='employeeid' value={formdata2.employeeid} class="form-control" onChange={(e) => handleChange(e)} />
                    <span className='error'>{newErrors.adduser.employeeid}</span>
                  </div>
                  <div className='col-md-3'>
                    <br />
                    <label>Add Permission <span className='error'>*</span></label>
                    <br />
                    <select class="form-control" required name="isadder" value={formdata2.isadder} onChange={(e) => handleChange(e)}>
                      <option value="">Select </option>
                      <option value="1">Enabled</option>
                      <option value="0">Disabled</option>
                    </select>
                    <span className='error'>{newErrors.adduser.isadder}</span>
                  </div>
                </div>
                <br />
                <br />

                <div className='row'>
                  <div>
                    <div className='pull-right'>
                      <span>
                        <Button type="submit" label="Save" icon="pi pi-check" severity="success" rounded />
                      </span>

                      <span>
                        <Button type="button" label="Close" severity="danger" onClick={() => setuserdialog(false)} rounded />
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </Dialog>

          <Dialog header="Upload Excel File" visible={isexceluploaddialog} style={{ width: '40%' }} closable={!isuploadingexcel} onHide={() => { if (isuploadingexcel) return; setexceluploaddialog(false); setSelectedExcelFile(null); }}>
            <div className='row'>
              <div className='col-md-12'>
                <label>Choose the filled Excel template (.xlsx) <span className='error'>*</span></label>
                <br />
                <br />
                <input type="file" className='form-control' accept=".xlsx" disabled={isuploadingexcel} onChange={selectExcelFileForUpload} />
                {isuploadingexcel && (
                  <div className='container-box' style={{ marginTop: '12px', alignItems: 'center' }}>
                    {loader.Smallloader()}
                    &nbsp;
                    <span>Uploading, please wait...</span>
                  </div>
                )}
              </div>
            </div>
            <br />
            <div className='row'>
              <div>
                <div className='pull-right'>
                  <span>
                    <Button type="button" label={isuploadingexcel ? 'Uploading...' : 'Upload'} icon="pi pi-check" severity="success" rounded loading={isuploadingexcel} disabled={isuploadingexcel} onClick={processSelectedExcelFile} />
                  </span>
                  <span>
                    <Button type="button" label="Close" severity="danger" rounded disabled={isuploadingexcel} onClick={() => { setexceluploaddialog(false); setSelectedExcelFile(null); }} />
                  </span>
                </div>
              </div>
            </div>
          </Dialog>

          <Dialog header="Multi User Upload" visible={ismultiuploaddialog} style={{ width: '95%' }} onHide={() => setmultiuploaddialog(false)}>
            <div style={{ overflowX: 'auto' }}>
              <table className="table table-bordered">
                <thead>
                  <tr>
                    <th style={{ minWidth: '50px' }}>Sr No</th>
                    <th style={{ minWidth: '150px' }}>Email address <span className='error'>*</span></th>
                    <th style={{ minWidth: '150px' }}>Name <span className='error'>*</span></th>
                    <th style={{ minWidth: '150px' }}>Date of Joining</th>
                    <th style={{ minWidth: '150px' }}>Date of Handover to Operations</th>
                    <th style={{ minWidth: '180px' }}>Name of the Project <span className='error'>*</span></th>
                    <th style={{ minWidth: '150px' }}>Department Name <span className='error'>*</span></th>
                    <th style={{ minWidth: '150px' }}>Team Name <span className='error'>*</span></th>
                    <th style={{ minWidth: '150px' }}>Role <span className='error'>*</span></th>
                    <th style={{ minWidth: '150px' }}>User Type <span className='error'>*</span></th>
                    <th style={{ minWidth: '150px' }}>project <span className='error'>*</span></th>
                    <th style={{ minWidth: '150px' }}>Aprover <span className='error'>*</span></th>
                    <th style={{ minWidth: '150px' }}>Cost Center <span className='error'>*</span></th>
                    <th style={{ minWidth: '120px' }}>Employee ID <span className='error'>*</span></th>
                    <th style={{ minWidth: '130px' }}>Add Permission <span className='error'>*</span></th>
                    <th style={{ minWidth: '60px' }}>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {multiuserrows.map((row, index) => (
                    <tr key={index} style={isMultiUserRowComplete(row) ? { backgroundColor: '#d4f8d4' } : undefined}>
                      <td className='text-center'>{index + 1}</td>
                      <td><input type='text' className='form-control' value={row.userid} onChange={(e) => handleMultiUserRowChange(index, 'userid', e.target.value)} /></td>
                      <td><input type='text' className='form-control' value={row.name} onChange={(e) => handleMultiUserRowChange(index, 'name', e.target.value)} /></td>
                      <td><input type='date' className='form-control' value={row.date_of_joining} onChange={(e) => handleMultiUserRowChange(index, 'date_of_joining', e.target.value)} /></td>
                      <td><input type='date' className='form-control' value={row.date_of_handovers} onChange={(e) => handleMultiUserRowChange(index, 'date_of_handovers', e.target.value)} /></td>
                      <td><input type='text' className='form-control' value={row.project_name} onChange={(e) => handleMultiUserRowChange(index, 'project_name', e.target.value)} /></td>
                      <td>
                        <select className='form-control' value={row.departmentname} onChange={(e) => handleMultiUserRowChange(index, 'departmentname', e.target.value)}>
                          <option value="">Select</option>
                          {deptcomp}
                        </select>
                      </td>
                      <td>
                        <select className='form-control' value={row.teamname} onChange={(e) => handleMultiUserRowChange(index, 'teamname', e.target.value)}>
                          <option value="">Select</option>
                          {teamcomp}
                        </select>
                      </td>
                      <td>
                        <select className='form-control' value={row.roletype} onChange={(e) => handleMultiUserRowChange(index, 'roletype', e.target.value)}>
                          <option value="">Select</option>
                          {rolecomp}
                        </select>
                      </td>
                      <td>
                        <select className='form-control' value={row.role} onChange={(e) => handleMultiUserRowChange(index, 'role', e.target.value)}>
                          <option value="">Select</option>
                          <option value="UL1">Manager</option>
                          <option value="CL1">Normal User</option>
                        </select>
                      </td>
                      <td>
                        <select className='form-control' value={row.project} onChange={(e) => handleMultiUserRowChange(index, 'project', e.target.value)}>
                          <option value="">Select</option>
                          {projectcomp}
                        </select>
                      </td>
                      <td>
                        <select className='form-control' value={row.approver} onChange={(e) => handleMultiUserRowChange(index, 'approver', e.target.value)}>
                          <option value="">Select</option>
                          {userscomp}
                        </select>
                      </td>
                      <td>
                        <select className='form-control' value={row.costcenter} onChange={(e) => handleMultiUserRowChange(index, 'costcenter', e.target.value)}>
                          <option value="">Select</option>
                          {costcentercomp}
                        </select>
                      </td>
                      <td><input type='number' className='form-control' value={row.employeeid} onChange={(e) => handleMultiUserRowChange(index, 'employeeid', e.target.value)} /></td>
                      <td>
                        <select className='form-control' value={row.isadder} onChange={(e) => handleMultiUserRowChange(index, 'isadder', e.target.value)}>
                          <option value="1">Enabled</option>
                          <option value="0">Disabled</option>
                        </select>
                      </td>
                      <td className='text-center'>
                        <FaTrash className='error custom-cursor-style' style={{ fontSize: '18px' }} onClick={() => removeMultiUserRow(index)} />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div className='container-box space-between'>
              <FaPlusCircle className='info-style custom-cursor-style' style={{ fontSize: '24px' }} title="Add Row" onClick={addMultiUserRow} />
              <div className='pull-right'>
                <span>
                  <Button type="button" label="Save All" icon="pi pi-check" severity="success" rounded onClick={submitMultiUsers} />
                </span>
                <span>
                  <Button type="button" label="Close" severity="danger" rounded onClick={() => setmultiuploaddialog(false)} />
                </span>
              </div>
            </div>
          </Dialog>

          <Dialog header="Edit User" visible={isdialogedit} style={{ width: '80%' }} onHide={() => setusereditdialog(false)}>
            <form onSubmit={edithandleSubmit}>
              <div className='col-md-12'>
                <div className='row'>
                  <div className='col-md-4'>
                    <label>User Id Or Email address <span className='error'>*</span></label>
                    <input type='text' required name='userid' value={formdataedit.userid} class="form-control" onChange={(e) => edithandleChange(e)} />
                    <span className='error'>{newErrors.edituser.userid}</span>
                  </div>
                  <div className='col-md-4'>
                    <label>Name <span className='error'>*</span></label>
                    <input type='text' required name='name' value={formdataedit.name} class="form-control" onChange={(e) => edithandleChange(e)} />
                    <span className='error'>{newErrors.edituser.name}</span>
                  </div>
                  <div className='col-md-4'>
                    <label>Date of Joining <span className='error'>*</span></label>
                    <br />
                    <input type="date" required className='custom-calender-style calender-custom-style'
                      name="date_of_joining" dateFormat='yy/mm/dd' value={formdataedit.date_of_joining} onChange={(e) => edithandleChange(e)} style={{ width: '100%' }} />
                    {/* <Calendar
                      className='calender-custom-style'
                      name="date_of_joining" dateFormat='yy/mm/dd' value={formdataedit.date_of_joining} onChange={(e) => edithandleChange(e)} style={{ width: '100%' }} /> */}
                      <span className='error'>{newErrors.edituser.date_of_joining}</span>
                  </div>

                  <div className='col-md-3'>
                    <br />
                    <label>Date of Handover to Operations</label>
                    <input type="date" className='custom-calender-style calender-custom-style'
                      name="date_of_handovers" dateFormat='yy/mm/dd' value={formdataedit.date_of_handovers} onChange={(e) => edithandleChange(e)} style={{ width: '100%' }}/>  
                    {/* <Calendar className='calender-custom-style'
                      name="date_of_handovers" dateFormat='yy/mm/dd' value={formdataedit.date_of_handovers} onChange={(e) => edithandleChange(e)} style={{ width: '100%' }} /> */}
                     
                  </div>

                  <div className='col-md-6'>
                    <br />
                    <label>Name of the Project <span className='error'>*</span></label>
                    <br />
                    <input type='text' required name='project_name' value={formdataedit.project_name} class="form-control" onChange={(e) => edithandleChange(e)} />
                    <span className='error'>{newErrors.edituser.project_name}</span>
                  </div>

                  <div className='col-md-3'>
                    <br />
                    <label>Department Name <span className='error'>*</span></label>
                    <br />
                    <select class="form-control" required name="departmentname" value={formdataedit.departmentname} onChange={(e) => edithandleChange(e)}>
                      <option value="">Select</option>
                      {deptcomp}
                    </select>
                    <span className='error'>{newErrors.edituser.departmentname}</span>
                  </div>

                  <div className='col-md-3'>
                    <br />
                    <label>Team Name <span className='error'>*</span></label>
                    <br />
                    <select class="form-control" required name="teamname" value={formdataedit.teamname} onChange={(e) => edithandleChange(e)}>
                      <option value="">Select</option>
                      {teamcomp}
                    </select>
                    <span className='error'>{newErrors.edituser.teamname}</span>
                  </div>

                  <div className='col-md-3'>
                    <br />
                    <label>Role <span className='error'>*</span></label>
                    <br />
                    <select class="form-control" required name="roletype" value={formdataedit.roletype} onChange={(e) => edithandleChange(e)}>
                      <option value="">Select</option>
                      {rolecomp}
                    </select>
                    <span className='error'>{newErrors.edituser.roletype}</span>
                  </div>
                  <div className='col-md-3'>
                    <br />
                    <label>User Type <span className='error'>*</span></label>
                    <br />
                    <select class="form-control" required name="role" value={formdataedit.role} onChange={(e) => edithandleChange(e)}>
                      <option value="">Select</option>
                      <option value="UL1">Manager</option>
                      <option value="CL1">Normal User</option>
                    </select>
                    <span className='error'>{newErrors.edituser.role}</span>
                  </div>

                  <div className='col-md-3'>
                    <br />
                    <label>project <span className='error'>*</span></label>
                    <br />
                    <select class="form-control" required name="project" value={formdataedit.project} onChange={(e) => edithandleChange(e)}>
                      <option value="">Select</option>
                      {projectcomp}
                    </select>
                    <span className='error'>{newErrors.edituser.project}</span>
                  </div>
                  <div className='col-md-3'>
                    <br />
                    <label>Aprover <span className='error'>*</span></label>
                    <br />
                    <select class="form-control" required name="approver" value={formdataedit.approver} onChange={(e) => edithandleChange(e)}>
                      <option value="">Select</option>
                      {userscomp}
                    </select>
                    <span className='error'>{newErrors.edituser.approver}</span>
                  </div>
                  <div className='col-md-3'>
                    <br />
                    <label>Cost Center <span className='error'>*</span></label>
                    <br />
                    <select class="form-control" required name="costcenter" value={formdataedit.costcenter} onChange={(e) => edithandleChange(e)}>
                      <option value="">Select</option>
                      {costcentercomp}
                    </select>
                    <span className='error'>{newErrors.edituser.costcenter}</span>
                  </div>
                  <div className='col-md-3'>
                    <br />
                    <label>Employee ID <span className='error'>*</span></label>
                    <br />
                    <input type='number' required name='employeeid' value={formdataedit.employeeid} class="form-control" onChange={(e) => edithandleChange(e)} />
                    <span className='error'>{newErrors.edituser.employeeid}</span>
                  </div>
                  <div className='col-md-3'>
                    <br />
                    <label>Add Permission <span className='error'>*</span></label>
                    <br />
                    <select class="form-control" required name="isadder" value={formdataedit.isadder} onChange={(e) => edithandleChange(e)}>
                      <option value="1">Enabled</option>
                      <option value="0">Disabled</option>
                    </select>
                    <span className='error'>{newErrors.edituser.isadder}</span>
                  </div>
                </div>
                <br />
                <br />

                <div className='row'>
                  <div>
                  {/* onChange={(e)=> subclientpower(e,value.id)} */}
                      <span>
                         {/* {formdataedit.status} */}
                         <ToggleButton style={{background:'orange',color:'white'}} checked={formdataedit.status == 1 ? true : false} 
                         onChange={(e) => updateuserstatus(e,formdataedit.id)}
                         onLabel="Deactivate" offLabel="Activate" onIcon="" offIcon="fa fa-cancel" className="w-8rem"/>
                      </span>
                    <div className='pull-right'>
                      <span>
                        <Button type="submit" label="Save" icon="pi pi-check" severity="success" rounded />
                      </span>

                      <span>
                        <Button type="button" label="Close" severity="danger" onClick={() => setusereditdialog(false)} rounded />
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </Dialog>
          <div className="col-md-12">
            {
              !isloaded ? loader.Loadermd() : (<table className="table table-bordered">
                <thead>
                  <tr>
                    <th scope="col">User Id</th>
                    <th scope="col">User Name</th>
                    <th scope="col">Project</th>
                    <th scope="col">Type</th>
                    <th scope="col">Verified On</th>
                    <th scope="col">Status</th>
                    <th scope="col">Reset</th>
                    <th scope="col">Edit</th>
                  </tr>
                </thead>
                <tbody>
                  {users}
                </tbody>
              </table>)
            }
          </div>
        </div>
      </div>
    </>
  );
}

export default BulkUsersuploadnew;